/**
 * What the product calls itself when a business has not renamed it.
 *
 * A business sets its own name in settings, and that name is what every screen
 * shows. This is only the fallback: the login page, which runs before any
 * business is known, and a fresh install that has never been configured.
 */
export const DEFAULT_SYSTEM_NAME = 'Stockpilot';
/** The name to show, given whatever a business has set. */
export function systemNameOf(systemName) {
    const name = systemName?.trim();
    return name && name.length > 0 ? name : DEFAULT_SYSTEM_NAME;
}
//# sourceMappingURL=branding.js.map